export const resettableBy = actionType => reducer => (state, action) => {
    if (action.type === actionType) {
        state = undefined;
    }

    return reducer(state, action);
};
